export const events = {
  goToExpenses: 'Go to expenses',
  addNewExpense: 'Add new expense',
  addNewExpenseOcr: 'Add new expense (ocr)',
  createNewExpense: 'Create new expense',
  editExistingExpense: 'Edit existing expense',
  bulkEditExistingExpense: 'Edit bulk existing expense',
  gotToCards: 'Go to cards',
  goToDownloadExportStart: 'Go to Download export Start',
  goToDownloadExportSubmit: 'Go to Download export Submit',
  goToExpensesReport: 'Go to Expenses report',
  goToExpensesSettings: 'Go to Expenses settings',
  goToExpensesFormSettings: 'Go to Expenses Form settings',
  goToExpensesFormFieldEdit: 'Go to Expense form field edit',
  goToMonth: 'Go to month',
  goToRequestInformation: 'Go to request information',
  goToCreateCardsAccountModal: 'Go to create cards account modal',
  goToCreateCardsAccount: 'Go to create cards account',
  goToCreateNonMainLegalEntityCardsAccount: 'Go to create non main legal entity cards account',
  goToCreateNonSupportedCountryCardsAccount: 'Go to create non-supported country cards account',
  selectLegalEntityCardsAccount: 'Select legal entity cards account',
  goToAccountSettings: 'Go to account settings',
  goToCompleteAccountCreation: 'Go to complete account creation',
  goToCompleteAccountMissingInformation: 'Go to complete account missing information',
  goToSettingsExternalIban: 'Go to set my external IBAN',
  gotToCreateCard: 'Go to create card',
  editNewCardtype: 'Edit new card type',
  createNewCardSubmit: 'Create new card Submit',
  gotToCardDetails: 'Go to card details',
  editCardStatus: 'Edit card status',
  editCardControls: 'Edit card controls',
  gotToAddFunds: 'Go to Add funds',
  goToSeeCardNumbers: 'Go to see card numbers',
  goToSeeCardPIN: 'Go to see card PIN',
  upgradeModalView: 'Upgrade modal view',
  goToUpgradeNow: 'Go to upgrade now',
  viewSkippableCardsLandingPage: 'View skippable cards landing page',
  viewSkippableCardsBanner: 'View skippable cards banner',
  goToCreateCardsAccountFromCardsBanner: 'Go to create cards account from cards banner',
  viewSkipProcessModal: 'View skip process modal',
  cancelSkipProcess: 'Cancel skip process',
  cancelSkipCardsBanner: 'Cancel skip cards banner',
  skipCardsLandingPage: 'Skip cards landing page',
  skipCardsBanner: 'Skip cards banner',
  faqDropdownCardClicked: 'FAQ dropdown card clicked ',
  dismissSingleUseCardBannerNotification: 'Dismiss notification for single use cards',
  filterExpenses: 'Filter expenses',
  quickFilterExpensesStatus: 'Quick filter by expenses status',
  uploadDocument: 'Upload expense document (OCR)',
  saveExpense: 'Save expense',
  newsBanner: 'Click on expenses news banner',
  filter: 'Apply any filter',
  expensesReportWidgetNavigation:
    'Accessing employee expenses by clicking any of the report widgets',
  expensesReportLoad: 'Load expenses report',
  // Per Diem
  goToPerDiemRatesConfig: 'Go to Per Diem Rates Configuration',
  clickAddNewPerDiemRate: 'Click Add New Per Diem Rate',
  createDiemRateConfiguration: 'Create Per Diem Rate Configuration',
  // Mileage rates
  goToMileageRatesConfig: 'Go to Mileage Rates Configuration',
  clickAddNewMileageRate: 'Click Add New Mileage Rate',
  createMileageRateConfiguration: 'Create Mileage Rate Configuration',
  // Duplicate expense alerts
  viewDuplicateExpense: 'View duplicate expense',
  checkAlertsTab: 'Check expense alerts tab',
  compareExpenses: 'Compare duplicate expenses',
  markNotDuplicate: 'Mark expense as not duplicate',
  removeAllDuplicateAlerts: 'Remove all duplicate alerts',
  rejectDuplicateExpense: 'Reject duplicate expense',
  // AI Policy Check
  clickCheckExpenseAgainstPolicy: 'Click check expense against policy',
  dismissAiPolicyCheck: 'Dismiss AI policy check',
  aiPolicyCheckFeedbackHelpful: 'AI policy check feedback helpful',
  aiPolicyCheckFeedbackNotHelpful: 'AI policy check feedback not helpful',
}
